import { Button, useNotify } from "react-admin";
import { Box } from "@mui/material";

import { documentRequests } from "api/documentsApi";
import { settings } from "app";
import { getFileFromUrl, previewFileFromUrl } from "server/components/DownloadFile";
import { DocumentsType } from "utils/constants";

const TemplateActions = ({ documentId }) => {
  const notify = useNotify();

  if (!documentId) return null;

  const url = `${settings.gatewayApi}/${documentRequests.getDocumentById(documentId, DocumentsType.PUBLIC)}`;

  // No file name — download.js then takes it from the X-File-Name response header.
  const handlePreview = () => previewFileFromUrl(url, null, notify);
  const handleDownload = () => getFileFromUrl(url, null, notify);

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 1 }}>
      <Button
        size="small"
        variant="outlined"
        label="Преглед"
        onClick={handlePreview}
      />
      <Button
        size="small"
        variant="outlined"
        label="Изтегляне"
        onClick={handleDownload}
      />
    </Box>
  );
};

export default TemplateActions;
